import type { TravelArticle } from "../../types";
import anini from "./anini";
import singapore from "./singapore";

// Order here = order of cards on /travel. Add a new article file, import it, list it.
export const travelArticles: TravelArticle[] = [anini, singapore];

export const findArticle = (slug?: string) =>
  travelArticles.find((a) => a.slug === slug);

// Card text: the standfirst if the article has one, otherwise its opening paragraph (clamped in CSS)
export const cardBlurb = (a: TravelArticle) => {
  if (a.standfirst) return a.standfirst;
  const first = a.body.find((b) => b.t === "p");
  return first && first.t === "p" ? first.text : "";
};

// City-states (Singapore) are their own country — don't print the name twice
export const placeLabel = (a: TravelArticle) =>
  a.place === a.country ? a.place : `${a.place}, ${a.country}`;

// The line under the title in the article hero
export const placeMeta = (a: TravelArticle) =>
  a.place === a.country ? a.coord : `${a.country} · ${a.coord}`;
